import { Injectable, OnDestroy, inject } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { SocketService } from './socket.service';
import { AuthStateService } from '../auth-state.service';
import { Router } from '@angular/router';
import { EVENT_GATEWAY } from '@core/enums/eventWebSocket.enum';

const onSessionRevoked = (authState: AuthStateService, router: Router) => () => {
  authState.clearSession();
  router.navigate(['/home']);
};

@Injectable({
  providedIn: 'root',
})
export class SessionRevokedListenerService implements OnDestroy {
  private readonly socketService = inject(SocketService);
  private readonly authState = inject(AuthStateService);
  private readonly router = inject(Router);
  private readonly destroy$ = new Subject<void>();

  private initialized = false;
  private readonly registeredSockets = new Set<string>();

  start(): void {
    if (this.initialized) return;
    this.initialized = true;

    const handler = onSessionRevoked(this.authState, this.router);

    this.socketService
      .obtenerTodosSockets()
      .pipe(takeUntil(this.destroy$))
      .subscribe((socketsMap) => {
        for (const [key, socketData] of socketsMap) {
          if (socketData.isConnected && !this.registeredSockets.has(key)) {
            this.registeredSockets.add(key);
            socketData.socket.on(EVENT_GATEWAY.SESSION_REVOKED, handler);
          }
          if (!socketData.isConnected) {
            this.registeredSockets.delete(key);
          }
        }
      });
  }

  stop(): void {
    this.initialized = false;
    this.registeredSockets.clear();
    this.destroy$.next();
  }

  ngOnDestroy(): void {
    this.stop();
  }
}
